import React, { useState } from "react";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Divider } from "primereact/divider";
import { facultiesApi } from "../../../services/nomenclatures/facultiesApi";
import { studentsApi } from "../../../services/students/studentsApi";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Button } from "primereact/button";
import * as XLSX from "xlsx";

const StudentCountsGroupedReport: React.FC = () => {
  const [facultyId, setFacultyId] = useState<number | null>(null);

  const { data: faculties } = facultiesApi.useGetFacultiesQuery();
  const { data: report, isFetching } = studentsApi.useGetStudentCountsGroupedQuery(facultyId as number, {
    skip: facultyId === null,
  });

  const exportToExcel = () => {
    if (!report?.data) return;

    const exportData = report.data.map(item => ({
      'Специалност': item.specialityName,
      'Курс': item.year,
      'Статус': item.status,
      'Група': item.groupName,
      'Брой студенти': item.studentCount
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    worksheet['!autofilter'] = { ref: worksheet['!ref'] || 'A1' };
    
    worksheet['!cols'] = [
      { wch: 30 },
      { wch: 10 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 }
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Справка студенти');
    XLSX.writeFile(workbook, 'справка-студенти.xlsx');
  };

  return (
    <div className="flex justify-content-center flex-wrap">
      <Card className="w-full mt-4">
        <div className="flex justify-content-between align-items-center">
          <h4>Справка за брой студенти по групи</h4>
          <Button
            icon="pi pi-file-excel"
            label="Експорт"
            className="p-button-success"
            onClick={exportToExcel}
            disabled={!report?.data || isFetching}
          />
        </div>
        <Divider />
        <div className="p-fluid formgrid grid">
          <div className="field col-12">
            <label htmlFor="facultyId">Факултет</label>
            <Dropdown
              id="facultyId"
              options={faculties?.data ?? []}
              optionLabel="name"
              optionValue="facultyId"
              placeholder="Изберете факултет"
              value={facultyId}
              onChange={(e: DropdownChangeEvent) => setFacultyId(e.value)}
              className="w-full"
            />
          </div>
          <div className="field col-12">
            <DataTable
              value={report?.data}
              loading={isFetching}
              emptyMessage="Няма намерени резултати"
              stripedRows
              paginator
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
              sortField="specialityName"
              sortOrder={1}
            >
              <Column field="specialityName" header="Специалност" sortable />
              <Column field="year" header="Курс" sortable />
              <Column field="status" header="Статус" sortable />
              <Column field="groupName" header="Група" sortable />
              <Column field="studentCount" header="Брой студенти" sortable />
            </DataTable>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default StudentCountsGroupedReport;
